module.exports = __webpack_public_path__ + "img/logo.ab818fcf.png";